import axios from 'axios'
import { GetServerUrl } from './common.js'

axios.defaults.baseURL = GetServerUrl();
export function httpGet({
  url,
  params = {}
}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params
    }).then((res) => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function httpPost({ url, data = {}, params = {} }) {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: 'post',
      transformRequest: [(data) => {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      data,
      params
    }).then(res => {
      resolve(res.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/hook/request.js